export default {
    Success: 25509,
    NotFound: 25000,
    InProgess: 25001,
    NotFoundSender: 25002,
    InvalidSenderEmail: 25003,
    EmptyMessage: 25004,
    NotFoundPerson: 25005,
    PersonNerverMail: 25006,
    PersonInvalidEmail: 25007,
    Other: 25008,
    ExistReport: 25510
}